import { DataFile, FilesState, FileType } from './filesReducer'

export const getFileById = (state: FilesState, fileId?: number | null) => {
  if (!fileId) {
    return null
  }

  return state.pageFiles[fileId] || state.userFiles[fileId]
}

export const getFilesByIds = (state: FilesState, fileIds: number[]) => {
  if (!fileIds) {
    return null
  }
  return fileIds.reduce(
    (prev, id) => ({
      ...prev,
      [id]: getFileById(state, id),
    }),
    {} as Record<number, DataFile | null>,
  )
}

export const getAllFiles = (state: FilesState) => {
  return {
    ...state.pageFiles,
    ...state.userFiles,
  }
}

export const getFilesByType = (state: FilesState, fileType: FileType) => {
  return Object.values({
    ...state.userFiles,
    ...state.pageFiles,
  }).filter(file => file.type === fileType) as DataFile[]
}

const filesSelectors = {
  getFileById,
  getFilesByIds,
  getFilesByType,
  getAllFiles,
}

export default filesSelectors
